import * as React from 'react';
export interface MenuContextType {
  drawerOnly: boolean;
  isOpen: boolean;
  popoverOnly: boolean;
  setIsOpen: (open: boolean) => void;
  showDrawer: boolean;
}
export const MenuContext = React.createContext<MenuContextType | undefined>(undefined);
export const useMenuContext = () => {
  const context = React.useContext(MenuContext);
  if (!context) {
    throw new Error('Menu components must be used within a Menu.Root');
  }
  return context;
};